<template>
    <form autocomplete="off">
        <div class="row gy-3">
            <div class="col-12">
                <label>Professional Body <span class="text-danger">*</span></label>
                <multiselect mode="single" searchable valueProp="id" trackBy="title" label="title"
                    :can-clear="false" :can-deselect="false"
                    :loading="isLoading" :class="`${v$.form.professional_body_id.$error ? 'is-invalid' : '' }`"
                    :options="professionalBodies"
                    v-model="form.professional_body_id" placeholder="--select --">
                    <template v-slot:option="{ option }">
                        <div class="">
                            <span>{{ option.title }}</span>
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.professional_body_id.$errors" :key="index"
                    class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <label>Membership Grade <span class="text-danger">*</span></label>
                <multiselect mode="single" searchable valueProp="id" trackBy="title" label="title"
                    :can-clear="false" :can-deselect="false"
                    :loading="isLoading" :class="`${v$.form.membership_grade_id.$error ? 'is-invalid' : '' }`"
                    :options="membershipGrades"
                    v-model="form.membership_grade_id" placeholder="--select --">
                    <template v-slot:option="{ option }">
                        <div class="">
                            <span>{{ option.title }}</span>
                        </div>
                    </template>
                </multiselect>
                <div v-for="(item, index) in v$.form.membership_grade_id.$errors" :key="index"
                    class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-lg-6">
                <label>Membership Number</label>
                <input type="text"
                    class="form-control"
                    placeholder="Enter membership number"
                    v-model="form.membership_number">
            </div>
            <div class="col-lg-6">
                <label>Date Admitted</label>
                <div>
                    <CommonDatePicker v-model="form.date_admitted"
                        :maxDate="new Date()"
                        :error="v$.form.date_admitted.$error" />
                </div>
                <div v-for="(item, index) in v$.form.date_admitted.$errors" :key="index"
                    class="text-danger small">
                    <span v-if="item.$message">{{ item.$message }}</span>
                </div>
            </div>
            <div class="col-12">
                <div class="d-flex justify-content-end mt-3">
                    <b-button
                        variant="primary"
                        type="button"
                        @click.prevent="editMode ? update() : create()">
                        {{ editMode ? 'Update' : 'Submit' }}
                    </b-button>
                </div>
            </div>
        </div>
    </form>
</template>

<script>
import { required, helpers } from "@vuelidate/validators";
import useVuelidate from "@vuelidate/core";

export default {
    setup() {
        return { v$: useVuelidate() };
    },
    props:{
        editItem:{
            type:Object,
            default:null
        },
        editMode:{
            type:Boolean,
            default:false
        }
    },
    data(){
        return{
            isLoading:false,
            form:{
                professional_body_id:"",
                membership_grade_id:"",
                membership_number:"",
                date_admitted:""
            },

            professionalBodies: [],
            membershipGrades: []
        }
    },
    validations(){
        return{
            form:{
                professional_body_id:{
                    required: helpers.withMessage("Professional body is required", required)
                },
                membership_grade_id:{
                    required: helpers.withMessage("Membership grade is required", required)
                },
                date_admitted:{
                    required: helpers.withMessage("Date admitted is required", required)
                }
            }
        }
    },
    methods:{
        create(){
            this.v$.$validate().then(result=>{
                if(!result){
                    this.alertError(this.v$.$errors[0].$message);return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post('/memberships/create', this.form)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false);
                    if(response.data.success){
                        this.$emit("addedItem", response.data.data);
                        this.resetForm();
                    }
                });
            });
        },
        update(){
            this.v$.$validate().then(result=>{
                if(!result){
                    this.alertError(this.v$.$errors[0].$message);return;
                }
                this.$store.dispatch("changeLoaderValue", true);
                this.$http.post(`/memberships/${this.editItem.id}/update`, this.form)
                .then(response => {
                    this.$store.dispatch("changeLoaderValue", false);
                    if(response.data.success){
                        this.$emit("updatedItem", response.data.data);
                        this.resetForm();
                    }
                });
            });
        },
        resetForm(){
            this.v$.$reset();
            this.$emit("closeMe");
        },
        getOptionData(){
            this.isLoading = true
            this.$http.get(this.absoluteApiUrl(`/attributes?type=PROFESSIONAL_BODY`)).then((response) => {
                this.isLoading = false
                if(response.data.success){
                    this.professionalBodies = response.data.data
                }
            })
            this.$http.get(this.absoluteApiUrl(`/attributes?type=MEMBERSHIP_GRADE`)).then((response) => {
                if(response.data.success){
                    this.membershipGrades = response.data.data
                }
            })
        }
    },
    created(){
        this.getOptionData();
        if(this.editMode){
            this.form = this.$filters.patchUpdatables(this.form, this.editItem);
        }
    }
}
</script>